import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CmsModule } from '@signature-it/ngx-generic/components/cms';
import { ContentloaderModule } from '@signature-it/ngx-generic/components/contentloader';
import { CartOrdersModuleGeneric } from '@signature-it/ngx-catalogue/components/cart/orders';
import { CartSummaryModuleGeneric } from '@signature-it/ngx-catalogue/components/cart/summary';
import { CartEmptyModuleGeneric } from '@signature-it/ngx-catalogue/components/cart/empty';
import { CartContinueActionsGenericModule } from '@signature-it/ngx-catalogue/components/cart-continue-actions';
import { CartComponentGeneric } from './cart';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ContentloaderModule,
        CartOrdersModuleGeneric,
        CartSummaryModuleGeneric,
        CartEmptyModuleGeneric,
        CmsModule,
        CartContinueActionsGenericModule,
        RouterModule.forChild([{
            path: '',
            component: CartComponentGeneric
        }])
    ],
    declarations: [CartComponentGeneric],
    exports: [CartComponentGeneric]
})
export class CartModuleGeneric {}
